var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('key-pad'),_c('connected-call-list',{attrs:{"type":_vm.type}}),_c('transfer-keypad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }